import { SimpleChanges } from '@angular/core';

export const isPropertyChangeValueNotNullOrUndefined = (
  propertyName: string,
  changes: SimpleChanges
) => {
  const currentValue = changes[propertyName]?.currentValue;
  return currentValue != null;
};
